@charset "UTF-8";

/* src/app/views/plans-details-edit/eligibility-details-edit/eligibility-details-edit.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: left;
  margin-top: 20px;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.title-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  width: 100%;
}
.title {
  display: block;
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(28px, 2.2vw, 48px);
  line-height: 1.2;
  color: #333333;
  margin: 10px 0 0 48px;
}
.sub-title {
  display: block;
  width: 100%;
  font-weight: normal;
  font-style: normal;
  font-size: clamp(14px, 1.1vw, 22px);
  line-height: 1.3;
  color: #5f5f5f;
  margin-top: 2px;
}
.container-body {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
}
.editing-items {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 8px 36px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.element-text-select {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-left: 0 !important;
  width: calc(100% + 24px);
  margin-right: -12px;
}
.element-text-select > [class*=col-] {
  padding: 0 12px 16px;
  min-width: 0;
}
.element-edit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-edit-input {
  margin-top: 5px;
  height: 39px !important;
  width: 100%;
}
.element-edit-filter {
  margin-bottom: 5px;
}
.description-width {
  width: 100% !important;
  max-width: 100% !important;
}
.element-option-select {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  min-width: 0;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-option-select-filter {
  margin-bottom: 5px;
}
:host ::ng-deep .element-option-select .p-dropdown .p-dropdown-label,
:host ::ng-deep .element-option-select .ui-dropdown .ui-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.space {
  margin-left: 0;
}
.space-two {
  margin-left: 0;
}
.disabled-input:disabled {
  background-color: #E5E5E5;
  color: #202020;
}
.message-edit {
  margin: 0;
  padding: 0;
}
.text-width {
  width: min(430px, 100%);
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.top-space {
  margin-top: 0;
}
.element-edit .p-dropdown,
.element-edit .ui-dropdown,
.element-edit .p-inputtext,
.element-edit .ui-inputtext,
.element-option-select .p-dropdown,
.element-option-select .ui-dropdown,
.element-option-select .p-inputtext,
.element-option-select .ui-inputtext {
  width: 100% !important;
}
textarea.large-text {
  width: 100% !important;
  min-height: 96px !important;
  height: 96px !important;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 20px 36px 20px 36px;
  margin: 0;
  margin-top: 20px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.action-button {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:hover:not(:disabled) {
  background: #044ea7;
}
.undo-action-button {
  width: 137px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.undo-action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.undo-action-button:hover {
  background: #044ea7;
}
button.undo-action-button:hover .undo-action-button-label {
  color: #ffffff;
}
@media only screen and (max-width: 1200px) {
  .container-header {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 15px;
  }
  .title {
    margin-left: 30px;
    font-size: 26pt;
    line-height: 40px;
  }
  .sub-title {
    margin-left: 30px;
    font-size: 14pt;
    line-height: 22px;
  }
  .editing-items {
    margin-left: 20px;
    flex-direction: column;
    align-items: stretch;
    padding: 6px;
  }
  .element-text-select,
  .element-edit,
  .element-option-select {
    margin-left: 0 !important;
    width: 100%;
  }
  .orange-text-box,
  .text-width {
    width: 100% !important;
    min-width: 0;
  }
  .space,
  .space-two {
    margin-left: 0;
  }
  .button-position,
  .position-button {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 16px 36px 16px 36px;
    margin: 20px 0 0 0;
    border-top: 1px solid #d9d9d9;
    box-sizing: border-box;
  }
  .action-button,
  .action-button-return,
  .undo-action-button {
    width: 120px;
    height: 40px;
    margin: 0 0 0 10px;
    float: none;
    font-size: 13pt;
  }
}
@media only screen and (max-width: 900px) {
  .container-header {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10px;
  }
  .title,
  .sub-title {
    margin-left: 20px;
    margin-top: 10px;
    font-size: 22pt;
    line-height: 32px;
  }
  .sub-title {
    font-size: 10pt;
    margin-top: 0;
  }
  .editing-items {
    margin-left: 10px;
    flex-direction: column;
    align-items: stretch;
    padding: 4px;
  }
  .element-text-select,
  .element-edit,
  .element-option-select {
    margin-left: 0 !important;
    width: 100%;
  }
  .orange-text-box,
  .text-width {
    width: 100% !important;
    min-width: 0;
  }
  .space,
  .space-two {
    margin-left: 0;
  }
  .button-position,
  .position-button {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    gap: 10px;
    padding: 14px 36px 14px 36px;
    margin: 20px 0 0 0;
    border-top: 1px solid #d9d9d9;
    box-sizing: border-box;
  }
  .action-button,
  .action-button-return,
  .undo-action-button {
    width: 110px;
    height: 36px;
    margin: 0 0 0 8px;
    font-size: 12pt;
  }
}
@media only screen and (max-width: 600px) {
  .container-header {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 5px;
  }
  .title,
  .sub-title {
    margin-left: 0;
    font-size: 16pt;
    line-height: 24px;
  }
  .sub-title {
    font-size: 9pt;
  }
  .editing-items {
    margin-left: 0;
    padding: 2px;
  }
  .element-text-select,
  .element-edit,
  .element-option-select {
    width: 100%;
    margin-left: 0 !important;
  }
  .orange-text-box,
  .text-width {
    width: 100% !important;
    min-width: 0;
  }
  .space,
  .space-two {
    margin-left: 0;
  }
  .button-position,
  .position-button {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    gap: 8px;
    padding: 14px 16px 14px 16px;
    margin: 20px 0 0 0;
    border-top: 1px solid #d9d9d9;
    box-sizing: border-box;
  }
  .action-button,
  .action-button-return,
  .undo-action-button {
    width: 100px;
    height: 32px;
    margin: 0 0 0 6px;
    font-size: 11pt;
  }
}
@media only screen and (max-width: 500px) {
  .title {
    margin-left: 0;
    font-size: 13pt;
    line-height: 20px;
  }
  .sub-title {
    font-size: 9pt;
    margin-left: 0;
  }
  .space-first,
  .space-second {
    margin-left: 0;
  }
  .text-width {
    width: auto;
  }
  .button-position,
  .position-button {
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    gap: 6px;
    padding: 14px 16px 14px 16px;
    margin: 20px 0 0 0;
    border-top: 1px solid #d9d9d9;
    box-sizing: border-box;
  }
  .action-button,
  .action-button-return,
  .undo-action-button {
    width: 90px;
    height: 28px;
    margin: 0 0 0 4px;
    font-size: 10pt;
  }
}
.editing-items {
  width: 100% !important;
  max-width: 1240px;
  margin: 0 auto;
  padding: 8px 36px 0;
}
.editing-items > .element-text-select {
  width: 100%;
  margin: 0;
  padding: 0 !important;
}
.editing-items > .element-text-select > .element-edit,
.editing-items > .element-text-select > .element-option-select {
  padding: 0 12px 16px;
}
.editing-items > .element-text-select > .element-edit.lg\:col-4,
.editing-items > .element-text-select > .element-option-select.lg\:col-4 {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.editing-items > .element-text-select > .element-edit.lg\:col-6,
.editing-items > .element-text-select > .element-option-select.lg\:col-6 {
  flex: 0 0 50% !important;
  max-width: 50% !important;
}
.editing-items > .element-text-select > .description-width {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.space,
.space-two {
  margin-left: 0 !important;
}
@media only screen and (max-width: 768px) {
  .editing-items {
    padding: 8px 16px 0;
  }
  .editing-items > .element-text-select > .element-edit,
  .editing-items > .element-text-select > .element-option-select,
  .editing-items > .element-text-select > .description-width {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
/*# sourceMappingURL=eligibility-details-edit.component-ASTAPLE6.css.map */
